import React from 'react';
import { formatMoney } from 'utils/formatMoney';

const statusClassname = (status) => {
  switch (status) {
    case 'dealpay-completed':
      return 'status-text--completed';

    case 'dealpay-cancelled':
      return 'status-text--pending';

    default:
      return '';
  }
};

const Item = ({ data }) => (
  <tr>
    <td>
      #
      {data.ID}
    </td>
    <td>
      <time>
        {data.formatted_date}
      </time>
    </td>
    <td>
      <strong>
        {formatMoney(data.amount)}
      </strong>
    </td>
    <td>
      <strong className={`status-text text-uppercase ${statusClassname(data.status)}`}>
        {data.status_text}
      </strong>
    </td>
  </tr>
);

export default Item;



// WEBPACK FOOTER //
// ./src/pages/Funds/PayoutHistory/item.js